import Card from '@mui/material/Card'
import type { SxProps } from '@mui/material/styles'

import { PageNavbar, type PageNavbarProps } from './PageNavbar'

type PageCardProps = {
  children: React.ReactNode
  sx?: SxProps
  slots?: {
    navProps?: PageNavbarProps
  }
}

export const PageCard = ({ children, sx, slots }: PageCardProps) => {
  return (
    <Card elevation={0} sx={{ p: 4, ...(slots?.navProps ? { pt: 0 } : {}), ...sx }}>
      {slots?.navProps && <PageNavbar {...slots.navProps} />}
      {children}
    </Card>
  )
}
